import { GroupChat } from "../api/gms/proposal-chat/proposal-chats-api-state";
import { ChatAttachment } from "../components/module/proposal-status/modal/preview-proposal/chats/chat-attachment-modal";

export const getMessageAttachment = (msg: GroupChat): ChatAttachment | null => {
    if (!msg.attachment_path || !msg.attachment_name) {
        return null;
    }
    return {
        id: msg.comment_id,
        messageId: msg.comment_id,
        name: msg.attachment_name,
        type: '',
        size: '',
        url: msg.attachment_path,
        uploadedBy: msg.commenter_name,
        uploadedAt: msg.created_at,
    };
};